import React, { useEffect, useMemo, useState } from 'react';
import { Users, X } from 'lucide-react';

const ParticipantsModal = ({ isOpen, onClose, title = 'Участники', participants = [], totalCount = 0 }) => {
  const [search, setSearch] = useState('');
  const filteredParticipants = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return participants;
    return participants.filter((participant) => {
      const name = String(participant.full_name || '').toLowerCase();
      const username = String(participant.username || '').toLowerCase();
      return name.includes(q) || username.includes(q);
    });
  }, [participants, search]);

  useEffect(() => {
    if (!isOpen) {
      setSearch('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-[70] flex items-center justify-center p-4" onClick={onClose}>
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-white border-b border-gray-200 px-5 py-4 flex items-center justify-between">
          <h3 className="text-lg font-bold text-gray-900 inline-flex items-center gap-2">
            <Users className="w-5 h-5 text-[#4897d2]" />
            {title}
          </h3>
          <button type="button" onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100 text-gray-500">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="px-5 py-4">
          <p className="text-sm text-gray-600 mb-3">Всего записано: {totalCount}</p>
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Поиск по имени или @username"
            className="w-full mb-3 px-3 py-2 border border-gray-200 rounded-lg text-sm"
          />
          {filteredParticipants.length > 0 ? (
            <div className="space-y-2">
              {filteredParticipants.map((participant) => (
                <div key={participant.id} className="px-3 py-2 rounded-lg border border-gray-200 bg-gray-50">
                  <p className="text-sm font-medium text-gray-900">
                    {participant.full_name || participant.username}
                  </p>
                  {participant.username && (
                    <p className="text-xs text-gray-500">@{participant.username}</p>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="text-sm text-gray-500">
              {participants.length > 0 ? 'Никого не нашли по вашему запросу.' : 'Пока никто не записался.'}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ParticipantsModal;
